module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/apache/localhost/www/Angular/task2/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0